import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Skeleton } from 'primereact/skeleton';
import { useEffect, useRef, useState } from 'react';
import { Toast } from 'primereact/toast';
import UsuarioServiceAPI from "../../service/UsuarioServiceAPI";

const Perfil = function() {

    const [carregandoDados, setCarregandoDados] = useState(true);
    const [carregandoAlterarSenha, setCarregandoAlterarSenha] = useState(false);
    const [senhaAtual, setSenhaAtual] = useState('');
    const [novaSenha1, setNovaSenha1] = useState('');
    const [novaSenha2, setNovaSenha2] = useState('');
    const toast = useRef();

    useEffect(() => {
        start();
    }, []);

    async function start() {
        setCarregandoDados(false);
    }

    async function handleAlterarSenha(e) {
        setCarregandoAlterarSenha(true);
        e.preventDefault();

        if(novaSenha1.length < 3)
            toast.current.show({ severity: 'error', summary: 'Erro', detail: 'A nova senha deve conter pelo menos 3 caracteres', life: 3000 });
        if(novaSenha1 != novaSenha2)
            toast.current.show({ severity: 'error', summary: 'Erro', detail: 'A nova senha e a confirmação não estão iguais', life: 3000 });

        if(novaSenha1.length < 3 || novaSenha1 != novaSenha2) {
            setCarregandoAlterarSenha(false);
            return;
        }

        const usuarioServiceAPI = new UsuarioServiceAPI();
        setCarregandoAlterarSenha(true);

        try {
            const res = await usuarioServiceAPI.alterarSenha(senhaAtual, novaSenha1, novaSenha2);
            setCarregandoAlterarSenha(false);
            toast.current.show({ severity: 'success', summary: 'Sucesso', detail: 'Senha alterada com sucesso', life: 3000 });
            setSenhaAtual('');
            setNovaSenha1('');
            setNovaSenha2('');
        } catch(ex) {
            if(ex?.response?.status == 400)
                toast.current.show({ severity: 'error', summary: 'Erro', detail: 'Ops, a senha atual não confere', life: 3000 });
            else
                toast.current.show({ severity: 'error', summary: 'Erro', detail: 'Ops, houve um erro desconhecido, tente novamente', life: 3000 });
            setCarregandoAlterarSenha(false);
        }
    }

    return (
        <div className='grid'>
            <div className='col-12 md:col-6 lg:col-4'>

                {
                    carregandoDados ?
                        <Skeleton height={200} />
                        :
                        <div className="card">
                            <Toast ref={toast} />
                            <h5 class="p-mt-0">Alterar senha</h5>

                            <form onSubmit={handleAlterarSenha}>
                                <div className='grid'>

                                    <div className='col-12'>
                                        <span style={{width:"100%"}} className="p-input-icon-left">
                                            <i className="pi pi-key"></i>
                                            <InputText value={senhaAtual} onChange={e => setSenhaAtual(e.target.value)} disabled={carregandoAlterarSenha} required name='nova_senha' style={{width:"100%"}} type="password" placeholder="Senha atual" />
                                        </span>
                                    </div>

                                    <div className='col-12'>
                                        <span style={{width:"100%"}} className="p-input-icon-left">
                                            <i className="pi pi-key"></i>
                                            <InputText value={novaSenha1} onChange={e => setNovaSenha1(e.target.value)} disabled={carregandoAlterarSenha} required name='nova_senha' style={{width:"100%"}} type="password" placeholder="Nova senha" />
                                        </span>
                                    </div>

                                    <div className='col-12'>
                                        <span style={{width:"100%"}} className="p-input-icon-left">
                                            <i className="pi pi-key"></i>
                                            <InputText value={novaSenha2} onChange={e => setNovaSenha2(e.target.value)} disabled={carregandoAlterarSenha} required name='nova_senha' style={{width:"100%"}} type="password" placeholder="Confirmação da nova senha" />
                                        </span>
                                    </div>

                                    <div className='col-12'>
                                        <Button type="submit" icon='pi pi-save' label='Salvar alterações' loading={carregandoAlterarSenha} />
                                    </div>

                                </div>
                            </form>

                        </div>
                }

            </div>
        </div>
    );
}

export default Perfil;